import styled from 'styled-components';

import THEME from '../../../../../constants/theme';

export const ScrollerContainer = styled.div.attrs({
  className: 'ScrollerContainer',
})`
  width: 100%;
  // background: white;
  display: flex;
  border-radius: 5px;
  overflow: hidden;
  min-height: 37px;
  height: 37px;
`;

interface FramePreviewContainerProps {
  isActive?: boolean;
  isSystolic?: boolean;
  isDiastolic?: boolean;
  isMidSystole?: boolean;
  isPreDiastole?: boolean;
  isDisabled?: boolean;
  hasSegmentationReference?: boolean;
  $hasRejectedReview?: boolean;
}

export const FramePreviewContainer = styled.div.attrs({
  className: 'FramePreviewContainer',
})<FramePreviewContainerProps>(
  ({
    isActive,
    isSystolic,
    isDiastolic,
    isMidSystole,
    isPreDiastole,
    isDisabled,
    hasSegmentationReference,
    $hasRejectedReview,
  }) => `
    /* Rejected reviews take priority, followed by segmentation references
       and then phase-based colors. */
    background: ${
      $hasRejectedReview
        ? '#592d32'
        : hasSegmentationReference
          ? '#9bd5ed'
          : isSystolic
            ? THEME.systole
            : isDiastolic
              ? THEME.diastole
              : isMidSystole
                ? THEME.midSystole
                : isPreDiastole
                  ? THEME.preDiastole
                  : '#ccc'
    };
    opacity: ${isActive ? 1 : isDisabled ? 0.5 : 0.7};
    border: 1px solid black;
    border-right: 0;
    padding: 2px 0;
    flex: 1;
    height: 35px;
    cursor: ${isDisabled ? 'default' : 'pointer'};
    color: ${$hasRejectedReview ? 'white' : 'black'};
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover {
      opacity: ${isDisabled ? 0.5 : 1};
    }
    &:first-child {
      border-radius: 5px 0 0 5px;
    }
    &:last-child {
      border-radius: 0 5px 5px 0;
      border-right: 1px solid black;
    }
  `
);

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  width: 100%;
`;

export const PageLabel = styled.span.attrs({
  className: 'PageLabel',
})`
  font-size: 14px;
  color: #ddd;
`;
